/**
 * @file ResetFilter
 */

'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ResetFilter
 * @classdesc 変更履歴絞り込み解除
 */
export default class ResetFilter {
	/**
	 * @constructor
	 * @param {jQuery} $e - #reset-filter
	 */
	constructor($e, controller) {
		console.log(`ResetFilter.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	}


	/**
	 * clickのコールバック
	 *
	 * @memberof ResetFilter
	 * @return {undefined}
	 */
	onClick() {
		console.log(`ResetFilter.onClick`);
		$('#status').val('');
		$('#changed_column').val('');
		$('#from').val('');
		$('#to').val('');
		const $tr = $('.tbody .tr');
		$tr.show();
		$('.tr-no-result').remove();
		$('.block-table-control .text span').show();
	};
}
